import { render, staticRenderFns } from "./OrganisationMobileCard.vue?vue&type=template&id=b7ad9678&scoped=true"
import script from "./OrganisationMobileCard.vue?vue&type=script&lang=js"
export * from "./OrganisationMobileCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7ad9678",
  null
  
)

export default component.exports